import React from "react";
import { GenericModal } from "../../Components";
import { CheckoutForm } from "./CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";

const StripeModal = ({ isVisible, setIsVisible, stripePromiseKey, planId }) => {
  return (
    <GenericModal
      show={isVisible}
      onHide={() => setIsVisible(false)}
      className="p-5"
    >
      <Elements stripe={stripePromiseKey}>
        <CheckoutForm
          planId={planId}
          setIsVisible={setIsVisible}
          //   newCoachHire={newCoachHire}
          //   isLoading={isLoading}
          //   setIsLoading={setIsLoading}
        />
      </Elements>
    </GenericModal>
  );
};

export default StripeModal;
